import { Tabs } from "@wix/design-system";
import React, { useContext } from "react";
import { RicosContext } from "./../../../ricos-context";
import { SETTINGS_TAB } from "../../consts";
import {
  SETTINGS_DESIGN_TAB,
  SETTINGS_GENERAL_TAB,
  SETTINGS_LAYOUT_TAB,
  SETTINGS_TABS
} from "../../data-hooks";
const TabNavigation = ({ activeTab, onTabChange }) => {
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(
    Tabs,
    {
      dataHook: SETTINGS_TABS,
      hasDivider: true,
      minWidth: "100%",
      alignment: "start",
      type: "uniformSide",
      size: "small",
      items: [
        {
          id: SETTINGS_TAB.layout,
          dataHook: SETTINGS_LAYOUT_TAB,
          title: t("Poll_PollSettings_Tab_Layout_TabName")
        },
        {
          id: SETTINGS_TAB.design,
          dataHook: SETTINGS_DESIGN_TAB,
          title: t("Poll_PollSettings_Tab_Design_TabName")
        },
        {
          id: SETTINGS_TAB.settings,
          dataHook: SETTINGS_GENERAL_TAB,
          title: t("Poll_PollSettings_Tab_Settings_TabName")
        }
      ],
      activeId: activeTab,
      onClick: (value) => onTabChange(value.id)
    }
  );
};
export {
  TabNavigation
};
//# sourceMappingURL=tab-navigation.js.map
